<template>
  <div class="">
    <div class="box">
      <Navigation :route="navigationRoute" class="mb-10"></Navigation>
      <div class="recommendCourseType">
        <a class="recommendCourseTypeItem" :class="{ 'recommendCourseTypeItemOn': e.id == query.typeId }" @click="getRcList(e.id)"
          href="javascript:void(0)" v-for="(e, i) in rcType" :key="i">{{ e.name }}</a>
      </div>
      <div class="flex-wrap" style="gap: 24px;">
        <div class="course-item" v-for="item in tableData.records" @click="handleDetail('/myTrain/course', item.id)">
          <img :src="item.img ? item.img : require('@/assets/images/defaultImg.jpg')" alt="">
          <div class="coure-info">
            <div class="course-title two-row">
              {{ item.name }}
            </div>
            <div class="flex-btw-ctr course-desc">
              <div style="width: 80%;">主讲人：{{ item.speaker }}</div>
              <div class="course-tip">{{ item.studyCount || 0 }}人学习</div>
            </div>
          </div>
        </div>
      </div>

      <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current" :page-size="10"
        layout="prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>


  </div>
</template>

<script>
import { getCourseList, getRecommendCourseType, getRecommendCourseList } from '@/api/index';
import Navigation from "@/components/Navigation.vue";
export default {
  components: {
    Navigation
  },
  data() {
    return {
      navigationRoute: [
        { name: '首页' },
        { name: '推荐课程' },
      ],
      query: {
        current: 1,
        size: 10,
        typeId: ''
      },
      tableData: { //表格数据
        total: 0,
        records: []
      },
      rcType: [],
      rcList: [],
      onId: ''
    };
  },
  created() {
    this.getRcType()
    // this.getList()
  },
  methods: {
    handleCurrentChange(val) {
      this.query.current = val
      this.getRcList()
    },
    getList() {
      getCourseList(this.query).then(res => {
        this.tableData.records = res.records
        this.tableData.total = res.total
      });
    },
    handleDetail(url, id) {
      this.$router.push({ path: url + '?id=' + id })
    },
    getRcType() {
      getRecommendCourseType().then(res => {
        this.rcType = res
        this.getRcList(this.rcType[0].id)
      })
    },
    getRcList(typeId) {
      this.query.typeId = typeId
      getRecommendCourseList(this.query).then(res => {
        this.tableData.records = res.records
        this.tableData.total = res.total
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 24px;
  background: #FFFFFF;
  margin-bottom: 20px;
}

.study {
  row-gap: 20px;
  column-gap: 23px;

  img {
    display: block;
    width: calc((100% - 23px) / 2);
    height: 146px;
    border-radius: 5px 5px 5px 5px;
    // margin-right: 22px;
    // margin-bottom: 20px;
    cursor: pointer;

    &:hover {
      transition: all 0.3s ease;
      transform: scale(1.05);
    }

    // &:nth-child(2n) {
    //   margin-right: 0;
    // }
    //  &:nth-last-child(-n + 2) {
    //   margin-bottom: 0;
    //  }
  }
}

.study-item {
  padding: 18px 20px;
  margin-bottom: 10px;
  background: linear-gradient(270deg, rgba(228, 56, 29, 0.06) 0%, rgba(216, 29, 16, 0.06) 100%);
  border-radius: 5px 5px 5px 5px;
  font-weight: 400;
  font-size: 14px;
  color: #767676;

  &:last-child {
    margin-bottom: 20px;
  }

  .study-title {
    font-weight: 500;
    font-size: 14px;
    color: #1A1A1A;
    line-height: 14px;
    margin-bottom: 10px;
  }

  .study-time {
    line-height: 14px;
  }

  .study-btn {
    width: 80px;
    height: 28px;
    background: linear-gradient(147deg, #F59A23 0%, #FF901A 98%);
    border-radius: 5px 5px 5px 5px;

    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
  }

  .score {
    display: flex;
    align-items: baseline;
    color: #E4381D;
  }
}

.study-item2 {
  background: linear-gradient(147deg, rgba(245, 154, 35, 0.06) 0%, rgba(255, 144, 26, 0.06) 98%);
}

.mystudy {
  width: 260px;
  height: 50px;
  font-size: 18px;
  color: #FFFFFF;
  background: #F9BC41;
  border-radius: 5px 5px 5px 5px;
  cursor: pointer;

  img {
    display: block;
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
}

.myerror {
  background: #E5514D;
}

.course-item {
  width: calc((100% - 72px) / 4);
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #EEEEEE;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    height: 152px;

    &:hover {
      transition: all 0.3s ease;
      transform: scale(1.05);
    }
  }

  .coure-info {
    padding: 10px 10px 15px 10px;

    .course-title {
      font-size: 16px;
      color: #1A1A1A;
      line-height: 24px;
      margin-bottom: 10px;
    }

    .course-desc {
      font-size: 14px;
      color: #767676;
      line-height: 14px;
    }

    .course-tip {
      width: 67px;
      line-height: 22px;
      background: #EEEEEE;
      border-radius: 4px 4px 4px 4px;

      font-size: 12px;
      text-align: center;
    }
  }

}

.recommendCourseType {
  padding: 10px 0;

  .recommendCourseTypeItem {
    padding: 0 15px;
    position: relative;
    border-right: 1px solid #9C9C9C;
    text-decoration: none;
    color: #E5514D;

    &:last-child {
      border: none;
    }
  }

  .recommendCourseTypeItemOn {
    color: #F9BC41;
  }
}
</style>
